<div class="dialog-container">
  <div class="header">
    <span class="title">
      {{ actionType ? "Decline work experience" : "Manager feedback" }}</span
    >
    <button class="close-btn" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" alt="Close" />
    </button>
  </div>

  <form [formGroup]="form" class="content">
    <div class="d-grid gap-2" *ngIf="!actionType">
      <app-input
        context="Normal"
        class="form-item"
        label=""
        [placeholder]="'Add your feedback'"
        type="textarea"
        lineRow="6"
        [control]="form.get('ccEmail')"
        [textareaMaxLength]="10000"
        [customErrorMessages]="customErrorMessages.ccEmail"
      >
      </app-input>
    </div>

    <div class="d-grid gap-2" *ngIf="actionType">
      <app-input
        context="Normal"
        class="form-item"
        label=""
        [placeholder]="'Enter reason for declining.'"
        type="textarea"
        lineRow="6"
        [control]="form.get('decline')"
        [textareaMaxLength]="10000"
        [customErrorMessages]="customErrorMessages.decline"
      >
      </app-input>
    </div>

    <div class="actions" *ngIf="!actionType">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="loading"
        (click)="onSend()"
      >
        {{ loading ? "Submiting..." : "Submit feedback" }}
      </button>
    </div>
    <div class="actions" *ngIf="actionType">
      <button type="button" class="btn btn-normal" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="loading"
        (click)="declineEvent()"
      >
        {{ loading ? "Declineing..." : "Decline" }}
      </button>
    </div>
  </form>
</div>
